import { useSelector } from 'react-redux';

export const MakeFields = () => {
  const { rut, purchaseDate, orderId, cud, sku } = useSelector(
    (state) => state.issuesSlice,
  );

  return [
    {
      name: 'sku',
      label: 'SKU',
      disabled: true,
      required: true,
      value: sku,
      hidden: true,
    },
    {
      name: 'cud',
      label: 'Cud',
      disabled: true,
      required: false,
      value: cud,
      hidden: true,
    },
    {
      name: 'orderId',
      label: 'Oc',
      disabled: true,
      required: true,
      value: orderId,
      hidden: true,
    },
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      textArea: '',
      disabled: true,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
      value: rut,
    },
    {
      name: 'purchaseDate',
      inputType: 'date',
      inputAdornment: '',
      label: 'Fecha de compra',
      textArea: '',
      disabled: true,
      required: true,
      value: purchaseDate,
      disableFuture: true,
      disablePast: false,
      helper: 'AAAA-MM-DD',
      hidden: true,
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      textArea: '',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      textArea: '',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      textArea: '',
      disabled: false,
      required: true,
    },
    {
      name: 'expectedDate',
      inputType: 'date',
      inputAdornment: '',
      label: 'Nueva fecha de entrega',
      textArea: '',
      disabled: false,
      required: true,
      disableFuture: false,
      disablePast: true,
      helper: 'AAAA-MM-DD',
    },
    {
      name: 'comment',
      multiline: true,
      rows: 4,
      inputAdornment: '',
      label: 'Escribir comentario',
      textArea: 'Escribir comentario',
      disabled: false,
      required: false,
      helper: '',
    },
  ];
};
